import { ChartSnapshot, SeriesData } from './chart.typings'

function seriesDataPointEqual(a: SeriesData | undefined, b: SeriesData | undefined): boolean {
    if (a === b) return true
    if (a == null || b == null) return a == null && b == null
    const ta = (a as { time?: number }).time
    const tb = (b as { time?: number }).time
    if (ta !== tb) return false

    const valueA = 'close' in a ? a.close : 'value' in a ? (a as { value?: number }).value : undefined
    const valueB = 'close' in b ? b.close : 'value' in b ? (b as { value?: number }).value : undefined
    if (valueA !== valueB) return false

    if ('open' in a && 'open' in b && a.open !== b.open) return false
    if ('high' in a && 'high' in b && a.high !== b.high) return false
    if ('low' in a && 'low' in b && a.low !== b.low) return false

    const labelA = (a as { label?: string }).label
    const labelB = (b as { label?: string }).label
    if (labelA !== labelB) return false

    return true
}

function seriesDataArrayEqual(a?: SeriesData[], b?: SeriesData[]): boolean {
    if (a === b) return true
    if (!a || !b || a.length !== b.length) return false
    for (let i = 0; i < a.length; i++) {
        if (!seriesDataPointEqual(a[i], b[i])) return false
    }
    return true
}

export function seriesGroupSnapshotEqual(
    a?: Record<string, SeriesData[]>,
    b?: Record<string, SeriesData[]>
): boolean {
    if (a === b) return true
    if (!a || !b) return !a && !b
    const keysA = Object.keys(a)
    const keysB = Object.keys(b)
    if (keysA.length !== keysB.length) return false
    for (const k of keysA) {
        if (!seriesDataArrayEqual(a[k], b[k])) return false
    }
    return true
}

export function chartSnapshotChangedKeys(prev: ChartSnapshot | undefined, next: ChartSnapshot): string[] {
    const keys = new Set([...Object.keys(prev ?? {}), ...Object.keys(next)])
    const changed: string[] = []
    keys.forEach((key) => {
        if (!seriesGroupSnapshotEqual(prev?.[key], next[key])) {
            changed.push(key)
        }
    })
    return changed
}
